import { render, staticRenderFns } from "./OtherContracts.vue?vue&type=template&id=8a78e828&"
import script from "./OtherContracts.vue?vue&type=script&lang=js&"
export * from "./OtherContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports